<template>
  <div class="box8">
    <pageTitle
      title="5大企业级重磅项目支撑<br />实战经验拿来即用"
      text="有实力才更自信，就业才能更容易！"
    />

    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in subject"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item.tit }}
        </div>
      </div>

      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in subject"
          :key="index"
        >
          <div class="block" ref="block">
            <div class="img-box">
              <div class="tag">点击查看大图</div>
              <img
                class="clickImg"
                :src="
                  require(`../../../assets/coursePage/cPuls/box8/${
                    index + 1
                  }.1.png`)
                "
                alt
              />
            </div>
            <div class="open">
              查看全部
              <img src="../../../assets/coursePage/ai/box11/open.png" alt />
            </div>

            <div class="text-box">
              <div class="block-top">
                <div class="title">{{ item.nav }}</div>
              </div>

              <div class="tag-title">项目介绍</div>

              <div class="into">{{ item.intro }}</div>

              <div class="tag-title">技术亮点</div>
              <div class="demo">
                <p v-for="i in item.lightpoint" :key="i">{{ i }}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="text-box">
          <div class="block-tops">
            <div class="title">{{ subject[this.cur].nav }}</div>
            <div class="close" @click="show = false"></div>
          </div>

          <div class="tag tag2">项目介绍</div>

          <div class="target">{{ subject[cur].intro }}</div>

          <div class="tag tag2">技术亮点</div>
          <div class="target">
            <p v-for="i in subject[cur].lightpoint" :key="i">{{ i }}</p>
          </div>
        </div>
      </div>
    </van-popup>

    <previewImage
      ref="previewImage"
      :list="list"
      @close="close"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import previewImage from "../common/previewImage.vue";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    previewImage,
  },
  data() {
    let that = this;
    return {
      show: false,
      isPreview: false,
      clickedIndex: 0,

      subject: [
        {
          tit: "项目一",
          nav: "Go语言微服务项目",
          imgarr: [
            {
              img: require("../../../assets/coursePage/cPuls/box8/1.1.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/1.2.png"),
            },
          ],
          intro:
            "IHome是一个基于分布式框架Go-micro开发的微服务Web应用。服务间通过Consul来完成服务发现与健康检查。使用Protobuf和gRPC框架完成数据交互。使用主流Gin框架进行业务实现，通过Gorm灵活操作数据库。项目遵循模块化设计，可方便动态扩展服务，自动部署。",
          lightpoint: [
            "隐藏资源管理和错误处理，用户仅需要关注应用的开发，服务高可用、高可靠；",
            "可将负载运行在由成千上万的机器联合而成的集群中；",
            "支持云平台、模块化、 插件化、可挂载、可组合且自动部署、自动伸缩、扩展。",
          ],
        },
        {
          tit: "项目二",
          nav: "入侵检测与网络攻防项目",
          imgarr: [
            {
              img: require("../../../assets/coursePage/cPuls/box8/2.1.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/2.2.png"),
            },
          ],
          intro:
            "网络私有应用监测系统主要由多核硬件平台、安全操作系统、监测引擎、数据关联分析、协同分析、升级管理、维护管理、综合管理等功能模块组成。",
          lightpoint: [
            "NetFlow原始流录制技术；",
            "VPN、即时通信、翻墙软件、通用应用加密等嗅探技术；",
            "网络安全威胁体系、XSS漏洞与过滤、WebShell防护、拒绝服务攻击；",
            "常见Web安全漏洞；",
            "沙盒框架。",
          ],
        },
        {
          tit: "项目三",
          nav: "Windows/Linux 跨平台企业项目",
          imgarr: [
            {
              img: require("../../../assets/coursePage/cPuls/box8/3.1.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/3.2.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/3.3.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/3.4.png"),
            },
          ],
          intro:
            "安全传输平台是一款基础设施类项目，为集团、企业信息系统提供统一、标准的信息安全服务。能够解决企业和企业之间、集团内部信息数据的传输安全、消息安全、身份鉴别和认证。成功解决了传统的安全产品部署分散、效率低下、系统脆弱等问题。",
          lightpoint: [
            "并发服务器开发；",
            "QT客户端开发；",
            "Win系统和Linux系统对接调试；",
            "表文编解码、socket通信、IPC机制读写。",
          ],
        },
        {
          tit: "项目四",
          nav: "游戏服务器开发项目",
          imgarr: [
            {
              img: require("../../../assets/coursePage/cPuls/box8/4.1.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/4.2.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/4.3.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/4.4.png"),
            },
          ],
          intro:
            "项目中游戏开发采用Unity3D游戏引擎，游戏框架采用FPS射击场景应用。后端服务器采用高性能、分式式解决方案，实现统一游戏或其他应用后端云平台。同时实现跨平台、高并发小文件的快速云服务功能。集群基础设施采用Docker容器搭建。",
          lightpoint: [
            "自定义可扩展的服务框架Zinx；",
            "IO多路复用结合可扩展线程池实现并发处理；",
            "Protobuf 和JSON 数据序列化；",
            "Docker多实例部署；",
            "高性能服务器Nginx。",
          ],
        },
        {
          tit: "项目五",
          nav: "Lars负载均衡系统项目",
          imgarr: [
            {
              img: require("../../../assets/coursePage/cPuls/box8/5.1.png"),
            },
            {
              img: require("../../../assets/coursePage/cPuls/box8/5.2.png"),
            },
          ],
          intro:
            "Lars是一个简单、易用、高性能的服务间远程调用管理、调度、负载均线系统。弹性负载均衡可将流量跨可用区进行分发，建立实时的同城容灾机制，能够满足银行贸易等企业对系统的高可用性要求。",
          lightpoint: [
            "集群支持千万并发链接，支持多可用区的容灾，无缝实时切换；",
            "自动分发，与弹性伸缩无缝集成；",
            "快速部署、实时生效，支持多种协议，多种调度算法，用户可高效的管理和调整服务分发策略。",
          ],
        },
      ],
      list: [],
      cur: 0,
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 75;
          },
          click(e) {
            console.log(e.target.className);
            if (
              e.target.className == "open" ||
              (that.$refs.block[0]._prevClass == "block" &&
                e.target.className != "clickImg" &&
                e.target.className != "tag" &&
                e.target.className !=
                  "swiperwrap swiper-slide swiper-slide-active")
            ) {
              that.show = true;
            }
            if (
              e.target.className == "clickImg" ||
              e.target.className == "tag"
            ) {
              that.list = that.subject[this.realIndex].imgarr;
              that.isPreview = true;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      console.log(index);
      this.swiper.slideTo(index, 500, false);
      this.cur = index;
    },
    close() {
      this.clickedIndex = 0;
      this.$refs.previewImage.changeCur();
      this.isPreview = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box8 {
  position: relative;
  // padding: 80px 0px;
  padding-top: 80px;
  width: 100%;
  overflow: hidden;
  background: url("../../../assets/coursePage/cPuls/box8/bgc.png") no-repeat;
  background-size: cover;
  .van-popup {
    padding-bottom: 24px;
    max-height: calc(100% - 80px);
    box-sizing: border-box;
  }
  .swiper-container {
    padding-top: 60px;
    padding-bottom: 66px;
    overflow: initial;
  }

  .subject-content {
    margin: 0 auto;
    margin-top: 48px;
    margin-bottom: 80px;
    padding: 24px;
    width: 686px;
    height: 682px;
    background: linear-gradient(180deg, #d5f2ff 0%, #ffffff 100%);
    border-radius: 20px;
    border: 2px solid #fff;

    backdrop-filter: blur(7px);
    box-sizing: border-box;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 16px;
      width: 316px;
      img {
        width: 40px;
        height: 40px;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(270deg, #65adff 0%, #1fd7cd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .demo-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 16px;
      .demo {
        margin-bottom: 18px;
        padding: 2px;
        width: 310px;
        height: 124px;

        border-radius: 16px;
        // border: 2px solid;
        background-image: linear-gradient(90deg, #eaf8fe 0%, #d0f0ff 100%);

        box-sizing: border-box;

        .demo-color {
          padding-top: 15px;
          padding-left: 47px;
          width: 306px;
          height: 120px;
          border-radius: 16px;
          background: #fff;
          box-sizing: border-box;
          p {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #86909c;
            line-height: 44px;
          }
        }

        .tit {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
          line-height: 44px;
        }
      }
    }
  }

  .subject-box {
    position: relative;
    margin: 0 auto;
    // padding-bottom: 22px;
    width: 100%;
    // overflow: hidden;
    .nav-box::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
    .nav-box {
      display: flex;
      justify-content: space-between;
      margin: 48px 0 0px;
      position: relative;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #1d2129;
      display: flex;
      justify-content: space-between;
      overflow-x: scroll;
      transition: all 0.2s;
      padding: 0 32px 0 32px;
      .nav {
        width: 138px;
        height: 68px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 68px;
        text-align: center;
        margin-right: 20px;
        flex-shrink: 0;
      }

      .cur-nav {
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);

        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;

        position: relative;
      }
    }
  }

  .swiper-slide {
    // padding: 0px 40px;
    padding-bottom: 22px;

    .block {
      position: relative;
      margin: 0 auto;
      padding: 40px 32px;
      padding-top: 0px;
      width: 690px;
      height: 700px;
      background-color: #ffffff;
      box-shadow: 0px 8px 29px 0px rgba(0, 129, 255, 0.25);
      border-radius: 20px;
      background-size: contain;
      background-repeat: no-repeat;

      box-sizing: border-box;

      .img-box {
        position: absolute;
        right: 28px;
        top: -20px;
        width: 200px;
        height: 128px;
        border: 4px solid #fff;
        box-shadow: 0px 24px 60px 0px rgba(94, 123, 218, 0.1),
          0px 12px 24px -16px rgba(94, 123, 218, 0.16);
        border-radius: 20px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }

        .tag {
          position: absolute;
          bottom: 0px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 152px;
          height: 40px;
          background: rgba(27, 27, 27, 0.7);
          border-radius: 0px 24px 0px 0px;

          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        border-radius: 0px 0px 20px 20px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      .text-box {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;

        margin-bottom: 30px;
        width: 373px;
        height: 96px;
        border-bottom: 1px solid #d3def0;

        .title {
          width: 100%;
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .tag-title {
        width: 152px;
        height: 52px;
        background: #e6f4ff;
        border-radius: 0px 32px 32px 24px;
        margin-bottom: 24px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0080ff;
        line-height: 52px;
        text-align: center;
      }

      .into {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        margin-bottom: 40px;
      }

      .demo {
        p {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
          width: 100%;
        }
      }

      .target {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
        p {
          margin-bottom: 12px;
        }
      }
    }
  }

  .swiper-pagination-box8 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      margin: 48px 0 32px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 56px;
    }
    .tag2 {
      margin-bottom: 24px;
    }
    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      p.indent {
        display: inline-block;
        text-align: justify;
        text-indent: -32px;
        padding-left: 40px;
      }
      p.indent:nth-child(9) ~ p.indent {
        text-indent: -43px;
        padding-left: 43px;
      }
    }
  }
}
</style>
